export const noSoccerQuery = {
	bool: {
		must_not: {
			term: {
				categoryGroupName: 'FOOTBALL',
			},
		},
	},
};
